import { Inject, Injectable } from "@angular/core";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { BehaviorSubject, Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  isLoggedSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isLoggedObs$ = this.isLoggedSubject$.asObservable();
  loginDisplay = false;

  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  ) {
    // TODO: azure stuff for auth
  }

  setup() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None,
        ),
        takeUntil(this._destroying$),
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    this.msalService.handleRedirectObservable().subscribe({
      error: (error) => console.error(error),
    });
  }

  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  getProfile() {
    let currentUser = this.msalService.instance.getActiveAccount();
    return currentUser;
  }

  async getSilentToken() {
    const profile = this.getProfile();
    const msalInstance = this.msalService.instance;
    try {
      const silentToken = await msalInstance.acquireTokenSilent({
        scopes: ["user.read"],
      });
      return silentToken.accessToken;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getTokenForPowerBiReports() {
    const msalInstance = this.msalService.instance;
    try {
      const silentToken = await msalInstance.acquireTokenSilent({
        scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
      });
      return silentToken.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        const interactiveToken = await msalInstance.acquireTokenPopup({
          scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
        });
        return interactiveToken.accessToken;
      } else {
        console.error("Failed to acquire token", error);
        throw error;
      }
    }
  }
}
